import { useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { Container } from 'swp-components/lib/components/bootstrap'
import { Button, DataLayer, Tabs } from 'swp-components/lib/components/common'
import {
  ExtraCard,
  PostpaidCard,
  PostpaidExtendedCard,
  PostpaidModal,
  PrepaidCard,
  PrepaidExtendedCard,
  PrepaidModal,
  TermsModal,
} from 'swp-components/lib/components/mobile-package'

import generateSliderOptions from '@/util/generate-slider-options'

import Slider from '../slider'
import style from './style'

const generateSlider = (tab, extended, setSelectedPack, setModal) => {
  let handleAction = (type, pack) => {
    return action => {
      if (action === 'show-detail') {
        setSelectedPack(pack)
        setModal(type)
      }

      if (action === 'show-terms') {
        setSelectedPack(pack)
        setModal('terms')
      }
    }
  }

  let sliderOptions = generateSliderOptions(extended ? 360 : 280)

  if (tab.type === 'postpaid') {
    let Card = extended ? PostpaidExtendedCard : PostpaidCard
    return (
      <>
        <div css={style.sliderWrapper}>
          <Slider options={sliderOptions}>
            {tab.packages.map(pack => (
              <div key={pack.id} css={style.box}>
                <Card pack={pack} onAction={handleAction('postpaid', pack)} />
              </div>
            ))}
          </Slider>
        </div>
        {tab.viewAll && (
          <div className="d-flex justify-content-center mt-3">
            <DataLayer
              selector={`MobilePackage.viewAllButton#${tab.title || 'none'}`}
              triggers={['click']}
              context={{ tab }}
              render={ref => (
                <Button ref={ref} variant="outlined" link={tab.viewAll.link}>
                  <FormattedMessage id="viewAll" defaultMessage="View All" />
                </Button>
              )}
            />
          </div>
        )}
      </>
    )
  }

  if (tab.type === 'prepaid') {
    let Card = extended ? PrepaidExtendedCard : PrepaidCard
    return (
      <>
        <div css={style.sliderWrapper}>
          <Slider options={sliderOptions}>
            {tab.packages.map(pack => (
              <div key={pack.id} css={style.box}>
                <Card pack={pack} onAction={handleAction('prepaid', pack)} />
              </div>
            ))}
          </Slider>
        </div>
        {tab.viewAll && (
          <div className="d-flex justify-content-center mt-3">
            <DataLayer
              selector={`MobilePackage.viewAllButton#${tab.title || 'none'}`}
              triggers={['click']}
              context={{ tab }}
              render={ref => (
                <Button ref={ref} variant="outlined" link={tab.viewAll.link}>
                  <FormattedMessage id="viewAll" defaultMessage="View All" />
                </Button>
              )}
            />
          </div>
        )}
      </>
    )
  }

  if (tab.type === 'extra') {
    return (
      <>
        <div css={style.sliderWrapper}>
          <Slider options={sliderOptions}>
            {tab.packages.map(pack => (
              <div key={pack.id} css={style.box}>
                <ExtraCard pack={pack} />
              </div>
            ))}
          </Slider>
        </div>
        {tab.viewAll && (
          <div className="d-flex justify-content-center mt-3">
            <DataLayer
              selector={`MobilePackage.viewAllButton#${tab.title || 'none'}`}
              triggers={['click']}
              context={{ tab }}
              render={ref => (
                <Button ref={ref} variant="outlined" link={tab.viewAll.link}>
                  <FormattedMessage id="viewAll" defaultMessage="View All" />
                </Button>
              )}
            />
          </div>
        )}
      </>
    )
  }
}

const renderContent = (packages, extended, setSelectedPack, setModal) => {
  if (packages.length === 1) {
    return generateSlider(packages[0], extended, setSelectedPack, setModal)
  }

  let tabs = packages.map(tab => ({
    key: tab.title,
    title: tab.title,
    pane: generateSlider(tab, extended, setSelectedPack, setModal),
  }))

  return (
    <Tabs
      tabs={tabs}
      tabItemTag="h3"
      wrapTabList={children => <Slider css={style.tabList}>{children}</Slider>}
    />
  )
}

const MobilePackage = ({ variant, packages, ...props }) => {
  let extended = variant === 'extended-card'

  let [selectedPack, setSelectedPack] = useState(null)
  let [modal, setModal] = useState('')

  let handleAction = action => {
    if (action === 'show-terms') {
      setModal('terms')
    }

    if (action === 'close-modal') {
      setModal('')
    }
  }

  return (
    <div {...props}>
      <Container>
        {renderContent(packages, extended, setSelectedPack, setModal)}
      </Container>
      <PostpaidModal
        pack={selectedPack}
        show={modal === 'postpaid'}
        onAction={handleAction}
      />
      <PrepaidModal
        pack={selectedPack}
        show={modal === 'prepaid'}
        onAction={handleAction}
      />
      <TermsModal
        pack={selectedPack}
        show={modal === 'terms'}
        onAction={handleAction}
      />
    </div>
  )
}

export default MobilePackage
